import { useEffect, useState } from "react";
import { appraisalSlice } from "../store/slices/Appraisal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getAppraisalData } from "../store/selectors";

const usePromoTicker = () => {
  const dispatch = useDispatch();
  const { promoLoading } = useSelector(getAppraisalData);

  const [startTicker, setStartTicker] = useState(false);

  const handleApplyPromo = () => {
    setStartTicker(true);

    setTimeout(() => {
      dispatch(appraisalSlice.actions.setPromoLoading(true));
      dispatch(appraisalSlice.actions.setPromoApplied(true));
    }, 2500);
  };

  useEffect(() => {
    if (promoLoading) {
      setTimeout(() => {
        dispatch(appraisalSlice.actions.setPromoLoading(false));
      }, 2500);
    }
  }, [promoLoading]);

  return { showLoader: promoLoading, handleApplyPromo, startTicker };
};

export default usePromoTicker;
